<!-- The Modal -->
<div class="modal fade" style="z-index: 99999;" *ngIf="show" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <header>{{entity_type}} has been saved successfully.</header>
            </div>
        </div>
    </div>
</div>